import { useAPI } from '../../state';
import { UIConfigData } from './interface';

// API endpoint constants
const UI_CONFIG_UPDATE_API = '/api/v1/ui-configs/columns';
const UI_CONFIG_RESET_API = '/api/v1/ui-configs/filters';
const UI_CONFIG_TYPE_API = '/api/v1/ui-configs/{type}';

/**
 * Hook for fetching UI configuration data by type
 * @param type - The UI configuration type to fetch
 * @returns [data, fetchFunction, clearFunction]
 */
export const useUIConfigAPI = (type?: string) => {
  return useAPI<UIConfigData>(UI_CONFIG_TYPE_API, { type });
};

/**
 * Hook for updating UI column configurations
 * @returns [response, updateFunction, clearFunction]
 */
export const useUpdateUIConfigAPI = () => {
  return useAPI(UI_CONFIG_UPDATE_API, {}, 'PUT');
};

/**
 * Hook for resetting UI filter configurations
 * @returns [response, resetFunction, clearFunction]
 */
export const useResetUIConfigAPI = () => {
  return useAPI(UI_CONFIG_RESET_API, {}, 'PUT');
};
